// extracted by mini-css-extract-plugin
module.exports = {"info":"_7184494b","photo":"_2d832aa9","title":"_487e5645","description":"_de2fcfe3","button":"_1f720953"};